import React from 'react';
import DesktopCalculator from './DesktopCalculator';
import MobileCalculator from './MobileCalculator';
import { getConfig } from './_calculator';
import { useLang } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';
import * as styles from './StepsCalculator.module.scss';

function StepsCalculator() {
  const lang = useLang();
  const preparedLang = lang === 'uk' || lang === 'kz' || lang === 'pl' ? 'en' : lang;
  const preparedConfig = getConfig(preparedLang);

  return (
    <>
      <DesktopCalculator className={styles.hiddenMobile} {...preparedConfig} />
      <MobileCalculator className={styles.hiddenDesktop} {...preparedConfig} />
    </>
  );
}

StepsCalculator.displayName = 'StepsCalculator';

export default withErrorBoundary(StepsCalculator);
